<template>
  <div class="background-connexion height-100">
    <div class="card">
      <div class="card-content-login has-background-white is-fixed">
        <div class="has-text-centered mgb-40px">
          <img src="/static/img/connexion/logoAffixe.svg" class="width-250"/>
        </div>
        <div class="has-text-centered mgb-40px">
          <h1 class="title is-size-4">
            {{ $t('connexion.resetPassword.title') }}
          </h1>
        </div>
        <error-msg-component :messages="messages" class="mgt-20px"
                             :error="isError"
                             :messagesChampsVide="messagesChampsVide"
                             :champsVide="champsVide"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="isError = $event"/>
        <form  @submit.prevent="resetPasswordForm()">
          <b-field :label="$t('connexion.nouveauMdp')"
            class="mgt-20px obligatoire" custom-class="has-text-default"
            :message="$t('firstStepUtilisateur.identifiantConnexion.messagePassword')">
            <b-input v-model="newPwd" type="password" password-reveal></b-input>
          </b-field>
          <b-field :label="$t('connexion.nouveauMdpConfirmation')"
                   class="mgt-20px obligatoire" custom-class="has-text-default">
            <b-input v-model="newPwdConfirmation" type="password" password-reveal></b-input>
          </b-field>
          <button class="button is-primary mgt-40px is-fullwidth has-text-weight-bold"
                  type="submit">
            {{ $t('connexion.actions.reinitialiser')}}
          </button>
        </form>
        <footer class="footer-connexion has-text-default is-size-8">
          {{ $t('connexion.info.produit')}}
        </footer>
      </div>
    </div>
  </div>
</template>

<script>

import errorMsgComponent from '@/components/general/errorMsgComponent';
import { resetPassword } from '@/services/utilisateur/motdepasseoublie';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import validation from '@/services/validation/validation';
import validationMdpOublie from '@/services/connexion/mdpOublieMessageErreur';
import validationUser from '@/services/parametrage/validation/validationModificationUtilisateur';

export default {
  name: 'FormReinitialisationMotDePasse',
  data() {
    return {
      messages: [],
      champsVide: [],
      newPwd: '',
      newPwdConfirmation: '',
      messagesChampsVide: [],
      isError: false,
      hash: '',
    };
  },
  components: {
    errorMsgComponent,
  },
  methods: {
    async resetPasswordForm() {
      const loadingComponent = this.$buefy.loading.open();
      this.isError = false;
      this.messages = [];
      this.messagesChampsVide = [];
      this.champsVide = [];
      try {
        if (this.newPwd.length > 0 && this.newPwd !== this.newPwdConfirmation) {
          throw new Error('MOT_PASSE_DIFFERENT');
        }
        await resetPassword({
          hash: this.hash,
          newPwd: this.newPwd,
        });
        messageSucces(this.$t('connexion.resetPassword.success'));
        loadingComponent.close();
        await this.$router.push({ name: 'connexion' });
      } catch (e) {
        this.isError = true;
        if (e.response?.data.error) {
          validation(this.$i18n, e.response, this.champsVide,
            this.messages,
            this.messagesChampsVide,
          );
          this.messages = validationMdpOublie(e.response, this.messages);
        } else if (e.message === 'MOT_PASSE_DIFFERENT') {
          validationUser(null, e.message, null, this.messages);
        } else {
          messageErreur(this.$i18n);
        }
        loadingComponent.close();
        throw e;
      }
    },
    initData() {
      this.hash = this.$route.query?.data;
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
